export const MEMBER_EDIT_PATHS = Object.freeze({
  CONTENT: "/content",
  MEMBERS: "/members",
  ADD_MEMBERS: "/add_members",
});
